export default "__VITE_ASSET__TVuABZFH__"